module.exports = __webpack_public_path__ + "img/workIcon.a911bed9.png";